<!--
 * @Author: guoyu
 * @Date: 2021-04-07 17:39:37
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-06 10:59:02
 * @Description: 新人優惠倒計時
-->
<template>
  <div>
    <div
      class="coupon-container"
      :class="{ mobile: isMobile }"
      v-if="(newerCoupon || !userInfo) && $route.path === '/' && !isEnd"
    >
      <div class="new-coupon">
        <div class="cundown-left">
          <span class="conpon-title">{{$t('upgrade_page_layout_new_coupon_1120')}}</span>
          <Countdown
            :endTime="endTime"
            type="dd/hh/mm/ss"
            @end="isEnd = true"
          ></Countdown>
        </div>
        <div class="use-coupon" @click="useCoupon">
          {{ userInfo ? $t('upgrade_page_views_order_components_coupons_bar_336') : $t('upgrade_page_layout_new_coupon_1121') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Countdown from '@/components/common/countdown';
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';
export default {
  components: {
    Countdown
  },
  data() {
    return {
      isEnd: false
    };
  },
  computed: {
    ...mapGetters(['newerCoupon', 'userInfo']),
    endTime() {
      if (this.newerCoupon && this.newerCoupon.deadlineTimestamp) {
        return this.newerCoupon.deadlineTimestamp;
      } else {
        const time = Date.now();
        const end = time + 86400 * 7 * 1000;
        return end;
      }
    },
    isMobile() {
      return window.innerWidth < 600;
    }
  },
  methods: {
    useCoupon() {
      if (!this.userInfo) {
        Login().then(() => {
          this.$router.push({ path: '/coupons' });
        });
      } else {
        this.$router.push({ path: '/coupons' });
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.coupon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  background: #fe7f38;
}
.new-coupon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 900px;
  color: #ffffff;
}
.cundown-left {
  display: flex;
  /deep/.time-num {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 24px;
    font-size: 14px;
    background: #ffe1cf;
    border-radius: 3px;
    color: #ff5b37;
  }
  /deep/ .time-unit {
    font-size: 20px;
    transform: scale(0.5) translateY(10px);
  }
}
.conpon-title {
  margin-right: 12px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.use-coupon {
  display: flex;
  align-items: center;
  @include button-yellow;
  height: 24px;
  padding: 0 22px;
  border-radius: 40px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}
.coupon-container {
  &.mobile {
    padding: 0 10px;
    .cundown-left {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      justify-content: center;
    }
    .conpon-title {
      font-size: 12px;
    }
    /deep/ .countdown-container {
      .time-num {
        border: none;
        background-color: inherit;
        color: white;
        width: auto;
        height: auto;
        font-size: 12px;
      }
      .time-unit {
        transform: none;
        font-size: 12px;
      }
    }
  }
}
</style>
